import { Box, ColorOptions, IconNew, SpacerNew, TextNew, useWindowDimensions } from '@jfs/ui-new'
import { FC, memo, useEffect, useState } from 'react'
import { DropdownOptimised } from '../../../../comps/DropdownNew'
import { DropdownTypes } from '../../../../comps/DropdownNew/types'
import { styles } from './ReportingStyles'

export const DownloadSample: FC = ({ handleDownloadSample, allValues }) => {
  const isValueAvailable =
    allValues?.reportFormat !== undefined &&
    allValues?.reportFormat !== '' &&
    allValues?.reportExt !== undefined &&
    allValues?.reportExt !== ''
  return (
    <Box
      flex={1}
      mt={28}
      minHeight={35}
      {...styles.downloadSample(isValueAvailable)}
      hoverColor={'TRANSPARENT'}
      underlayColor={'ALTO_DISABLED'}
      testID="download-sample"
      onPress={
        isValueAvailable ? () => handleDownloadSample(allValues?.reportFormat, allValues?.reportExt) : undefined
      }>
      <TextNew {...styles.downloadStyleText(isValueAvailable)} title={'Download Sample Report'} />
    </Box>
  )
}

export const ReportingFormat = memo(({ handleDownloadSample, setFieldValue, fieldName, allValues }) => {
  const [reportValue, toggleReportValue] = useState(undefined)

  useEffect(() => {
    if (allValues?.reportingFormat) {
      toggleReportValue(allValues?.reportingFormat)
    }
  }, [allValues])

  const width = useWindowDimensions()

  return (
    <Box {...styles.mainView}>
      <Box {...styles.textAndIcon}>
        <Box {...styles.titleAligner}>
          <TextNew title="Reporting Format" {...styles.titleText} />
        </Box>
        <Box {...styles.iconContainer}>
          <IconNew id={'INFO'} color={'#202F4D8A' as ColorOptions} size={14} />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />
      <Box {...styles.superContainer}>
        <DropdownOptimised
          placeHolder={'Select a settlement report format'}
          data={[
            { id: '1', value: 'Standard' },
            { id: '2', value: 'Premium' },
            { id: '3', value: 'Basic' },
            { id: '4', value: 'Explanatory' },
          ]}
          value={reportValue}
          type={DropdownTypes.DEFAULT_DOWNLOAD_REPORT}
          onChange={(val: any) => {
            if (setFieldValue && fieldName) {
              setFieldValue(fieldName, val)
            }
            toggleReportValue(val)
          }}
          disabled={false}
          buttonWidth={width / 4}
          titleColor={reportValue !== undefined ? 'BLACK_21' : 'LIGHT_GREY_INTRO'}
          borderColor={'#B9CBF0' as ColorOptions}
          testID={'ReportDropdown'}
          dropdownWidth={width / 4}
        />
        <DownloadSample handleDownloadSample={handleDownloadSample} reportValue={reportValue} />
      </Box>
    </Box>
  )
})
